import { render } from "./CreateDivision.vue?vue&type=template&id=6ccbbee0"
import script from "./CreateDivision.vue?vue&type=script&lang=js"
export * from "./CreateDivision.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__